/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'

import { Paper, Box, Typography, Button, Divider } from '@material-ui/core'

import { Collapse } from 'components'
import CollapseHeader from './../CollapseHeader'
import CollapseBody from './components/CollapseBody'
import useCollapse from 'hooks/useCollapse'
import useSnackbar from 'hooks/useSnackbar'
import { useParams } from 'react-router-dom'
import * as service from 'service'
import helpers from 'helpers'
import moment from 'moment'

const ContractsEditPlans = ({ contract }) => {
  const collapse = useCollapse()
  const snackbar = useSnackbar()
  const params = useParams()

  React.useEffect(() => {
    contract.contractPlans.forEach(contractPlan => {
      collapse.add({
        ...contractPlan,
        contractPlanEntries: helpers.contractPlanEntries.normalizeReceived(
          contractPlan.contractPlanEntries,
        ),
        collapseSettings: { updatedOnce: false, edit: false, expand: false },
      })
    })
  }, [])

  const handleClickAddPlan = () => {
    collapse.add({
      plan: null,
      periodicity: '',
      quantity: '',
      price: 0,
      contractPlanEntries: [{ quantity: '', price: 0 }],
      collapseSettings: { edit: true },
    })
  }

  const updateContractPlan = async contractPlan => {
    const contractId = params.contractId
    const normalizedContractPlanEntry = helpers.contractPlanEntries.normalizeSend(
      contractPlan.contractPlanEntries,
    )

    const lastEntry = contractPlan.contractPlanEntries[0]

    if (
      normalizedContractPlanEntry.length === 0 &&
      !!lastEntry.id &&
      !contractPlan.removable
    ) {
      await service.recurrence.contractPlanEntries.inactivate({
        contractPlanId: contractPlan.id,
        contractPlanEntryId: lastEntry.id,
      })
      normalizedContractPlanEntry.pop()
    }
    const response = await service.recurrence.contractPlans.update({
      contractId,
      contractPlanId: contractPlan.id,
      contractPlan: {
        code: contractPlan.plan.code,
        name: contractPlan.plan.name,
        price: parseFloat(contractPlan.price),
        periodicity: parseInt(contractPlan.periodicity),
        quantity: parseInt(contractPlan.quantity),
        contractPlanEntries: normalizedContractPlanEntry,
      },
    })

    collapse.update(contractPlan.collapseId, {
      ...response.data.contractPlan,
      contractPlanEntries: helpers.contractPlanEntries.normalizeReceived(
        response.data.contractPlan.contractPlanEntries,
      ),
      collapseSettings: { expand: false, edit: false },
    })

    collapse.setUpdatedOnce(contractPlan.collapseId, false)
  }

  const createContractPlan = async contractPlan => {
    const contractId = params.contractId

    const response = await service.recurrence.contractPlans.create({
      contractId,
      contractPlan: {
        code: contractPlan.plan.code,
        name: contractPlan.plan.name,
        price: parseFloat(contractPlan.price),
        periodicity: parseInt(contractPlan.periodicity),
        quantity: parseInt(contractPlan.quantity),
        contractPlanEntries: helpers.contractPlanEntries.normalizeSend(
          contractPlan.contractPlanEntries,
        ),
      },
    })

    collapse.update(contractPlan.collapseId, {
      ...response.data.contractPlan,
      contractPlanEntries: helpers.contractPlanEntries.normalizeReceived(
        response.data.contractPlan.contractPlanEntries,
      ),
      collapseSettings: { expand: false, edit: false },
    })
    collapse.setUpdatedOnce(contractPlan.collapseId, false)
    return response.data.contractPlan.id
  }

  const sendPlans = async () => {
    const contractId = params.contractId
    const dueDate = moment().format('YYYY/MM/DD')
    const plansEdit = collapse.data.filter(contracts => {
      return contracts.collapseSettings.updatedOnce && contracts.id
    })

    const plansNew = collapse.data.filter(contracts => {
      return !contracts.id
    })

    try {
      const [, respPlansEdit] = await Promise.all([
        Promise.all(plansEdit.map(plan => updateContractPlan(plan))),
        Promise.all(plansNew.map(plan => createContractPlan(plan))),
      ])

      if (respPlansEdit.length && !contract.postPaid) {
        await service.recurrence.invoices.create({
          contractId,
          invoice: {
            invoiceType: 'R',
            dueDate,
            skipContractEntries: true,
            contractPlanIds: respPlansEdit,
          },
        })
      }

      snackbar.open({
        message: 'Plano(s) atualizado com sucesso!',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message: 'Erro ao salvar o(s) plano(s)!',
        variant: 'error',
      })
    }
  }

  const plansUpdatedOnce = collapse.data.some(
    contractPlan => contractPlan.collapseSettings.updatedOnce,
  )
  const editingPlans = collapse.data.some(
    contractPlan => contractPlan.collapseSettings.edit,
  )

  return (
    <Paper>
      <Box
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h4">Planos cadastrados na assinatura</Typography>
        <Button color="primary" variant="outlined" onClick={handleClickAddPlan}>
          Novo
        </Button>
      </Box>
      <Divider />
      <Box p={2}>
        <Collapse
          collapseHeader={CollapseHeader}
          collapseBody={CollapseBody}
          expansionPanelProps={{ TransitionProps: { unmountOnExit: true } }}
        />
      </Box>
      {plansUpdatedOnce && (
        <Box p={2}>
          <Typography variant="body1" color="textSecondary">
            É necessario salvar as alterações feitas no(s) plano(s).
            {!contract.postPaid &&
              ' Ao salvar, será gerada a fatura do(s) plano(s) adicionado(s).'}
          </Typography>
          <Box mt={2}>
            <Button
              color="primary"
              variant="contained"
              disabled={editingPlans}
              onClick={sendPlans}
            >
              Salvar alterações
            </Button>
          </Box>
        </Box>
      )}
    </Paper>
  )
}

export default ContractsEditPlans
